<template>
  <div id="last-purchase-details">
    <h2>Última compra</h2>
    <div class="information-row"><span class="bold">Fecha</span>: {{ selectedVehicle.last_purchase.last_purchase_at }}</div>
    <div class="information-row"><span class="bold">Estatus de la compra</span>: {{ selectedVehicle.last_purchase.order_status }}</div>
    <div class="information-row"><span class="bold">Total</span>: {{ selectedVehicle.last_purchase.purchase_total }}</div>
    <div class="information-row"><span class="bold">Detalles</span>: {{ selectedVehicle.last_purchase.message }}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'LastPurchaseDetails',
  computed: {
    ...mapGetters('saleOrderForm', ['selectedVehicle'])
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

#last-purchase-details {
  border-radius: 1.5rem;
  background-color: $white;
  margin: 1rem 2rem;
  padding: 1rem 2rem 2rem;
  width: 50%;
}

.information-row {
  margin: 1rem 0;
}

.bold {
  font-weight: bold;
}
</style>
